import React from "react";

const AddedHeroBackground = () => {

    return (
      <React.Fragment>
          <div className='added_background'>
              picked
          </div>
      </React.Fragment>
    );
  };
  
  export default AddedHeroBackground;